import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

const ContactItem = ({ t, contact }) => (
    <div className="contact-card">
        <div className="contact-card__content">
            <ul>
                <li className="contact-card__content__full-name">{contact.name}</li>
                <li className="contact-card__content__address">{contact.address}</li>
                <li className="contact-card__content__info">
                    <h6 className="contact-card__content__info__category">{t('contacts.tel')}</h6>
                    <div className="contact-card__content__info__content contact-card__content__info__tel">
                        {contact.tel}
                    </div>
                </li>
                <li className="contact-card__content__info">
                    <h6 className="contact-card__content__info__category">E-mail</h6>
                    <div className="contact-card__content__info__content contact-card__content__info__email">
                        {contact.emails.map((email, i) => (
                            <a href={`mailto:${email}`} key={i}>
                                {email}
                            </a>
                        ))}
                    </div>
                </li>
            </ul>
        </div>
    </div>
)

ContactItem.propTypes = {
    t: PropTypes.func
}

export { ContactItem }
export default withTranslation()(ContactItem)
